import { defineStore } from "pinia";

export const useFormDataStore = defineStore({
	id: "formData",
	state: () => {
		return {
			recaptchaSiteKey: "6Le6zdYkAAAAABM1GWz5othSTriQ4liVNrSUJOBL",
			recaptchaObject: null,
			campaignId: null,
			testMode: null,
			formParams: null,
			completedFn: null,
			mealOnly: true,
			S1FormData: {},
			S1StudentInfoData: {},
			S2FormData: {},
			S3FormData: {},
			formSubmissionData: {},
			countryOptions: [
				{ name: "Canada", code: "CA" },
				// { name: "United States", code: "US" },
			],
			provinces: [
				"Alberta",
				"British Columbia",
				"Manitoba",
				"New Brunswick",
				"Newfoundland and Labrador",
				"Northwest Territories",
				"Nova Scotia",
				"Nunavut",
				"Ontario",
				"Prince Edward Island",
				"Québec",
				"Saskatchewan",
				"Yukon Territory",
			],
			provinceOptions: [
				{ name: "Alberta", code: "AB" },
				{ name: "British Columbia", code: "BC" },
				{ name: "Manitoba", code: "MB" },
				{ name: "New Brunswick", code: "NB" },
				{ name: "Newfoundland and Labrador", code: "NL" },
				{ name: "Northwest Territories", code: "NT" },
				{ name: "Nova Scotia", code: "NS" },
				{ name: "Nunavut", code: "NU" },
				{ name: "Ontario", code: "ON" },
				{ name: "Prince Edward Island", code: "PE" },
				{ name: "Quebec", code: "QC" },
				{ name: "Saskatchewan", code: "SK" },
				{ name: "Yukon Territory", code: "YT" },
			],
			stateOptions: [
				// { name: "Alabama", code: "AL" },
				// Alaska: "AK",
				// "American Samoa": "AS",
				// Arizona: "AZ",
				// Arkansas: "AR",
				// California: "CA",
				// Colorado: "CO",
				// Connecticut: "CT",
				// Delaware: "DE",
				// "District Of Columbia": "DC",
				// Florida: "FL",
				// Georgia: "GA",
				// Guam: "GU",
				// Hawaii: "HI",
				// Idaho: "ID",
				// Illinois: "IL",
				// Indiana: "IN",
				// Iowa: "IA",
				// Kansas: "KS",
				// Kentucky: "KY",
				// Louisiana: "LA",
				// Maine: "ME",
				// Maryland: "MD",
				// Massachusetts: "MA",
				// Michigan: "MI",
				// Minnesota: "MN",
				// Mississippi: "MS",
				// Missouri: "MO",
				// Montana: "MT",
				// Nebraska: "NE",
				// Nevada: "NV",
				// "New Hampshire": "NH",
				// "New Jersey": "NJ",
				// "New Mexico": "NM",
				// "New York": "NY",
				// "North Carolina": "NC",
				// "North Dakota": "ND",
				// "Northern Mariana Islands": "MP",
				// Ohio: "OH",
				// Oklahoma: "OK",
				// Oregon: "OR",
				// Pennsylvania: "PA",
				// "Puerto Rico": "PR",
				// "Rhode Island": "RI",
				// "South Carolina": "SC",
				// "South Dakota": "SD",
				// Tennessee: "TN",
				// Texas: "TX",
				// Utah: "UT",
				// Vermont: "VT",
				// "Virgin Islands": "VI",
				// Virginia: "VA",
				// Washington: "WA",
				// "West Virginia": "WV",
				// Wisconsin: "WI",
				// Wyoming: "WY",
			],
		};
	},
	actions: {
		setRecaptchaObject(object) {
			this.recaptchaObject = object;
		},
		setCampaignId(id) {
			this.campaignId = id;
		},
		setTestMode(state) {
			this.testMode = state;
		},
		setFormParams(paramData) {
			this.formParams = paramData;
		},
		setCompletedFn(fn) {
			this.completedFn = fn;
		},
		setS1FormData(formData) {
			this.S1FormData = formData;
		},
		setS1StudentInfoData(formData, studentNumber) {
			this.S1StudentInfoData["student" + studentNumber] = formData;
		},
		setS2FormData(formData) {
			this.S2FormData = formData;
		},
		setS3FormData(formData) {
			this.S3FormData = formData;
		},
		setFormSubmissionData(formData) {
			this.formSubmissionData = formData;
		},
	},
});
